// extracted by mini-css-extract-plugin
export default {"cls1":"RIQuestion-cls1__b1207103398f1cff8cc6","cls2":"RIQuestion-cls2___fc8bc0055cdb59b7405 RIQuestion-cls1__b1207103398f1cff8cc6"};